module.exports = __webpack_public_path__ + "src/assets/img/listen.27be0ea1.png";